import { render, staticRenderFns } from "./ListClass.vue?vue&type=template&id=0bc95e44&"
import script from "./ListClass.vue?vue&type=script&lang=js&"
export * from "./ListClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports